import { IQueryTypeFragments } from '../../QueryFragments';
import { QueryType } from '../Default';

const productMediumImagesFragment = `
    on ${QueryType.product} {
        media {
            medium {
                src
                alt
            }
        }
    }
`;

export const productMediumImagesFragments = (): IQueryTypeFragments => {
    return {
        [QueryType.product]: productMediumImagesFragment
    };
};
